export default (zip) => {
  const validateZip = /(^\d{5}$)|(^\d{5}-\d{4}$)/
  return validateZip.test(zip)
}
